import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: '小雅',
    role: '上班族・學習中',
    duration: '學習 8 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20relaxed%20young%20taiwanese%20woman%20with%20soft%20smile%2C%20warm%20natural%20light%2C%20minimal%20background%2C%20warm%20beige%20tones%2C%20lifestyle%20photography%2C%20candid%20and%20genuine%20expression&width=200&height=200&seq=avatar01&orientation=squarish',
    quote: '以前學過鋼琴，停掉了很多年。體驗課之後感覺這裡完全不一樣——老師不問我現在在哪個程度，只問我想要什麼樣的感覺。這讓我很放鬆。',
    highlight: '不問程度，只問感覺',
    category: '成人初學',
    featured: true,
  },
  {
    name: '曉峰',
    role: '工程師・學習中',
    duration: '學習 1 年 2 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20calm%20thoughtful%20asian%20man%20in%20his%20thirties%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20background%2C%20genuine%20relaxed%20expression%2C%20minimal%20lifestyle%20photography&width=200&height=200&seq=avatar02&orientation=squarish',
    quote: '我一開始很擔心自己沒有音樂細胞，但老師讓我發現我其實對聲音很敏感，只是以前沒有機會好好感受。現在每週的上課時間是我最期待的一件事。',
    highlight: '每週最期待的事',
    category: '完全初學',
    featured: true,
  },
  {
    name: '佳惠',
    role: '三個孩子的媽',
    duration: '學習 6 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20gentle%20warm%20taiwanese%20mother%20in%20her%20forties%2C%20soft%20afternoon%20light%2C%20natural%20smile%2C%20warm%20linen%20background%2C%20candid%20lifestyle%20photography&width=200&height=200&seq=avatar03&orientation=squarish',
    quote: '一開始以為自己沒辦法堅持，結果上了幾次課之後根本停不下來。老師很了解我的生活節奏，不會催我練多少，但每次課後我都有想要繼續的感覺。',
    highlight: '根本停不下來',
    category: '成人學習',
    featured: false,
  },
  {
    name: '思穎的媽媽',
    role: '孩子 7 歲・學習中',
    duration: '孩子學習 10 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20kind%20taiwanese%20woman%20smiling%20warmly%2C%20soft%20warm%20natural%20light%2C%20minimal%20clean%20background%2C%20genuine%20and%20welcoming%20expression%2C%20portrait%20lifestyle%20photography&width=200&height=200&seq=avatar04&orientation=squarish',
    quote: '我女兒很容易對事情失去興趣，但古箏是唯一一件她會主動說「可以去上課嗎」的事。老師讓她覺得是在玩，不是在練習，這點讓我很感動。',
    highlight: '主動說想去上課',
    category: '兒童學習',
    featured: true,
  },
  {
    name: '柏勳',
    role: '大學生・學習中',
    duration: '學習 5 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20young%20asian%20man%20in%20his%20early%20twenties%2C%20relaxed%20and%20thoughtful%20expression%2C%20warm%20natural%20backlight%2C%20casual%20lifestyle%20photography%2C%20soft%20warm%20tones&width=200&height=200&seq=avatar05&orientation=squarish',
    quote: '我是因為壓力太大才開始找一件可以放鬆的事。體驗課前超緊張，但一進去就放鬆了——老師完全不像我想像中嚴肅的樂器老師。',
    highlight: '一進去就放鬆了',
    category: '紓壓學習',
    featured: false,
  },
  {
    name: '淑芬阿姨',
    role: '退休教師',
    duration: '學習 1 年 4 個月',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20graceful%20taiwanese%20woman%20in%20her%20sixties%2C%20warm%20smile%2C%20soft%20window%20light%2C%20elegant%20and%20peaceful%20expression%2C%20lifestyle%20portrait%20photography%2C%20muted%20warm%20tones&width=200&height=200&seq=avatar06&orientation=squarish',
    quote: '退休後想找一件屬於自己的事，古箏是我一直想學但覺得「老了才學來不及」的樂器。老師說現在才是最好的時候，我信了，真的沒有後悔過。',
    highlight: '現在才是最好的時候',
    category: '熟齡學習',
    featured: false,
  },
];

function useVisible(threshold = 0.1) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return { ref, visible };
}

export default function TestimonialsSection() {
  const { ref, visible } = useVisible();
  const [activeFilter, setActiveFilter] = useState('全部');

  const filters = ['全部', '成人初學', '完全初學', '成人學習', '兒童學習', '紓壓學習', '熟齡學習'];
  const filtered =
    activeFilter === '全部'
      ? testimonials.filter((t) => t.featured)
      : testimonials.filter((t) => t.category === activeFilter);

  return (
    <section className="py-20 md:py-28 bg-[#f5f0e8]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div
          ref={ref}
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-6 h-px bg-[#b08060]"></div>
                <span className="text-[0.8125rem] tracking-[0.2em] text-[#b08060] font-medium uppercase">
                  Testimonials
                </span>
              </div>
              <h2
                className="font-serif-tc text-[#2c2420] leading-[1.3]"
                style={{ fontSize: 'clamp(1.625rem, 3vw, 2.25rem)' }}
              >
                學員真實心聲
              </h2>
            </div>
            <p className="text-[0.9375rem] leading-[1.75] text-[#7a6e62] max-w-xs">
              不同背景、不同年齡，但都在這裡找到了屬於自己的學習節奏。
            </p>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap gap-2 mb-10">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActiveFilter(f)}
                className={`px-4 py-1.5 rounded-full text-[0.875rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeFilter === f
                    ? 'bg-[#5a3e22] text-white'
                    : 'bg-white border border-[#e8ddd0] text-[#5a4e42] hover:border-[#c8b49a]'
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((t, i) => (
              <div
                key={t.name}
                className="bg-white rounded-2xl border border-[#ede5d8] p-6 flex flex-col gap-5 hover:border-[#c8b49a] transition-all duration-300"
                style={{ transitionDelay: `${i * 0.07}s` }}
              >
                {/* Quote */}
                <div className="flex-1">
                  <div className="w-7 h-7 flex items-center justify-center mb-4">
                    <i className="ri-double-quotes-l text-[#c8a96e] text-2xl"></i>
                  </div>
                  <p className="text-[0.9375rem] leading-[1.8] text-[#4a3e32] mb-4">
                    {t.quote}
                  </p>
                  {/* Highlight pill */}
                  <span className="inline-block px-3 py-1 rounded-full bg-[#f5f0e8] text-[#7a6248] text-[0.75rem] font-medium">
                    ✦ {t.highlight}
                  </span>
                </div>

                {/* Divider */}
                <div className="h-px bg-[#f0e8dc]"></div>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-[#f0e8dc]">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-[0.9375rem] font-semibold text-[#2c2420]">{t.name}</p>
                    <p className="text-[0.8125rem] text-[#9a8470]">{t.role}</p>
                  </div>
                  <div className="ml-auto">
                    <span className="text-[0.75rem] text-[#9a8878] bg-[#f5f0e8] px-2.5 py-1 rounded-full whitespace-nowrap">
                      {t.duration}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom note */}
          <div className="mt-10 text-center">
            <p className="text-[0.875rem] text-[#9a8470]">
              以上為學員真實回饋，姓名已做部分匿名處理以保護隱私。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}